import Vue from 'vue'
import Store from '@/store/index'
import VueRouter, { Route } from 'vue-router'
import { isExpired, logOut } from '../plugins/auth'
import SubmitTest from '../utils/service/SubmitTest'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'top_page',
    component: () => import('../components/pages/TopPage.vue'),
  },
  {
    path: '/debug',
    name: 'debug_page',
    component: () => import('../components/pages/DebugPage.vue'),
    meta: {
      header: {
        title: 'デバッグ用',
      },
    },
  },
  {
    path: '/debug/combine',
    name: 'debug_page_combine',
    component: () => import('../components/pages/DebugPageCombine.vue'),
    meta: {
      header: {
        title: 'デバッグ用（コンバイン）',
      },
    },
  },
  {
    path: '/overseas_downloads',
    name: 'overseas_downloads',
    component: () => import('../components/pages/ContentsPdf.vue'),
    meta: {
      header: {
        title: '教材PDF版',
      },
    },
  },
  {
    path: '/new/contents',
    name: 'manabi_grade',
    component: () => import('../components/pages/ManabiGrade.vue'),
    meta: {
      header: {
        title: 'まなびチャンネル学年選択画面',
      },
    },
  },
  {
    path: '/new/contents/:grade_id',
    name: 'new_contents_manabi',
    component: () => import('../components/pages/NewContentsManabi.vue'),
    meta: {
      header: {
        title: 'まなびチャンネルコンテンツ表示画面',
      },
    },
  },
  {
    path: '/new/overseas_downloads',
    name: 'overseas_downloads_grade',
    component: () => import('../components/pages/PdfGrade.vue'),
    meta: {
      header: {
        title: 'PDF版学年選択画面',
      }
    }
  },
  {
    path: '/new/overseas_downloads/:grade_id',
    name: 'new_overseas_downloads',
    component: () => import('../components/pages/NewContentsPdf.vue'),
    meta: {
      header: {
        title: 'PDF版コンテンツ表示画面',
      }
    }
  },
  {
    path: '/contents',
    name: 'contents_manabi',
    component: () => import('../components/pages/ContentsManabi.vue'),
    meta: {
      header: {
        title: 'まなびチャンネル',
      },
    },
  },
  {
    path: '/play_video',
    name: 'play_video',
    component: () => import('../components/pages/PlayVideo.vue'),
    meta: {
      header: {
        title: 'まなびチャンネル',
      },
    },
  },
  {
    path: '/tensaku/',
    name: 'SubmitTestMember',
    component: () => import('../components/pages/SubmitTestMember.vue'),
    meta: {
      requireMemberAuth: true,
      header: {
        title: '添削テスト',
      },
    },
  },
  {
    path: '/tensaku_visiter/',
    name: 'SubmitTestNotMember',
    component: () => import('../components/pages/SubmitTestNotMember.vue'),
    meta: {
      requireVisiterAuth: true,
    },
  },
  {
    path: '/tensaku/submit',
    name: 'how_to_use',
    component: () => import('../components/pages/HowToUse.vue'),
    meta: {
      requireMemberAuth: true,
      header: {
        title: '添削テスト',
      },
    },
  },
  {
    path: '/tensaku_visiter/submit',
    name: 'how_to_use_not_member',
    component: () => import('../components/pages/HowToUse.vue'),
    meta: {
      requireVisiterAuth: true,
    },
  },
  {
    path: '/tensaku/photograph',
    name: 'PhotographMember',
    component: () => import('../components/pages/Photograph.vue'),
    meta: {
      requireMemberAuth: true,
      header: {
        title: '添削テスト',
      },
    },
  },
  {
    path: '/tensaku_visiter/photograph',
    name: 'PhotographNotMember',
    component: () => import('../components/pages/Photograph.vue'),
    meta: {
      requireVisiterAuth: true,
    },
  },
  {
    path: '/tensaku_visiter/regist',
    name: 'Regist',
    component: () => import('../components/pages/Regist.vue'),
  },
  {
    path: '/tensaku_visiter/regist/:exam_id',
    name: 'RegistPerExam',
    component: () => import('../components/pages/RegistPerExam.vue'),
  },
  {
    path: '/tensaku_visiter/regist_result',
    name: 'RegistResult',
    component: () => import('../components/pages/RegistResult.vue'),
  },
  {
    path: '/tensaku_visiter/regist_result/:codes',
    name: 'RegistResultWithCodes',
    component: () => import('../components/pages/RegistResult.vue'),
  },
  {
    path: '/tensaku_visiter/sign_in',
    name: 'SignIn',
    component: () => import('../components/pages/SignIn.vue'),
  },
  {
    path: '/tensaku_visiter/sign_in/:exam_id',
    name: 'SignInPerExam',
    component: () => import('../components/pages/SignInPerExam.vue'),
  },
  {
    path: '/tensaku_visiter/faq/:exam_id',
    name: 'FAQ',
    component: () => import('../components/pages/FAQ.vue'),
  },
  {
    path: '/tensaku_visiter/faq/:exam_id/:id',
    name: 'FAQContent',
    component: () => import('../components/pages/FAQContent.vue'),
  },
  {
    path: '/tensaku_visiter/device',
    name: 'TargetEnv',
    component: () => import('../components/pages/TargetEnv.vue'),
  }
]

const commonMeta = {
  member: {
    title: '',
    titleTemplate: '%s ｜名探偵コナンゼミマイページ',
    description: '名探偵コナンゼミの会員サイトです。ナゾトキゲーム、テキストといっしょに使う映像、学習ゲーム、添削テストの提出やテストの記録、各種お手続きをご用意しています。',
    keywords: 'コナンゼミ,コナン,通信教育,謎解き,小学生,学習ゲーム,名探偵コナン,小学館,家庭学習,勉強,学習漫画,まなびwith(ウィズ)',
  },
  visiter: {
    title: 'テスト提出',
    titleTemplate: '%s ｜小学館思考力テスト',
    description: '『小学一年生』9月号に掲載の名探偵コナンゼミ「小学館思考力テスト」提出サイトです。テストの提出、採点済みテスト、答えと解説、アドバイスシートの閲覧ができます。',
    keywords: '思考力,テスト,添削,コナンゼミ,コナン,通信教育,謎解き,小学生,名探偵コナン,小学館,家庭学習,勉強',
  },
}
// タイトルなどのヘッダを設定する
const setHeader = (to: Route) => {
  const header = Object.assign({}, Store.state.isMemberPage ? commonMeta.member : commonMeta.visiter)
  if (to.meta?.header) {
    Object.assign(header, to.meta.header)
  }
  const title = header.titleTemplate ? header.titleTemplate.replace('%s', header.title) : header.title
  const description = header.description
  const keywords = header.keywords
  document.title = title
  document.querySelector("meta[name='description']")?.setAttribute('content', description)
  document.querySelector("meta[name='keywords']")?.setAttribute('content', keywords)
}

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach(async (to, from, next) => {
  Store.commit('SET_MEMBERID', { memberId: null })
  const toPath = to.path || location.href
  Store.commit('SET_CURRENT_PATH', { path: toPath })
  Store.commit('SET_PREV_PATH', { path: from.path })

  Store.commit('SET_IS_MEMBER_PAGE', { isMemberPage: !to.path.includes("/tensaku_visiter") })
  setHeader(to)

  // テスト提出の会員専用ページのログインチェック
  if (to.matched.some(x => x.meta?.requireMemberAuth)) {
    if (! Vue.$cookies.get('submit_member_id')) {
      next('/sign_in')
      return
    }
  }

  // テスト提出の非会員専用ページのログインチェック
  if (to.matched.some(x => x.meta?.requireVisiterAuth)) {
    if (!(Store.state as any).user?.uid) {
      const examId =  Store.state.examInfo?.examGroupKey
      next(`/tensaku_visiter/sign_in/${examId}`)
      return
    }
  }

  // 添削完了メールから開いた場合
  if (to.matched.some(x => ['SignIn', 'SignInPerExam'].includes(x.name as string)) && to.query.nendo) {
    const examId = to.params['exam_id']
    await SubmitTest.countMailAccess(examId, parseInt(to.query.nendo.toString()))
    next(`/tensaku_visiter/sign_in/${examId}`)
    return
  }

  if (isExpired()) {
    logOut()
    Vue.prototype.$axios.delete('/api/v1/auth/sign_out')
    next('/sign_in');
  } else {
    Store.commit('user/setLastOperatedDate', { lastOperatedDate: new Date })
    next()
  }

  next()
})

export default router
